/**
 * **Die Claude-Anbindung – was beide Seiten wissen müssen** ([Z-21](../../../docs/phasen/zusatz-21-claude-anbindung.md)).
 *
 * Der Zustand einer KI-Lösung lebt nur in Work. Er ist bewusst **nicht** der Aufgabenstatus:
 * der wird nach GitLab und NetCon zurückgeschrieben, und dort lesen Kunden mit.
 */
export const KI_LOESUNG_ZUSTAENDE = [
  'offen',
  'in_arbeit',
  'vorschlag',
  'rueckfrage',
  'erledigt',
] as const
export type KiLoesungZustand = (typeof KI_LOESUNG_ZUSTAENDE)[number]

export const KI_LOESUNG_ZUSTAND_LABELS: Record<KiLoesungZustand, string> = {
  offen: 'wartet auf Claude',
  in_arbeit: 'Claude arbeitet daran',
  vorschlag: 'Lösung liegt vor',
  rueckfrage: 'Claude hat eine Rückfrage',
  erledigt: 'erledigt',
}

export const KI_ENTWURF_STATUS = ['offen', 'uebernommen', 'verworfen'] as const
export type KiEntwurfStatus = (typeof KI_ENTWURF_STATUS)[number]

/** Mindestlänge des Grundes, wenn personenbezogene Daten an Claude gehen. */
export const KI_GRUND_MIN = 10
